module.exports = __webpack_public_path__ + "static/media/cnn.776e75e0.png";